import { render, staticRenderFns } from "./RolesCRUD.vue?vue&type=template&id=77cf6b7f&"
import script from "./RolesCRUD.vue?vue&type=script&lang=js&"
export * from "./RolesCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports